import { tns } from 'tiny-slider/src/tiny-slider';
import { isMobile } from '../../../../../utils';
import SamplesModal from '../../../../Sample/SamplesModal';


/**
 *  Mobile Slider
 */
class MobileSlider {
  constructor(options) {
    this.container = options.container;

    this.state = {
      currentItem: undefined,
      currentIndex: undefined,
      slideCount: undefined,
      pdfLink: undefined,
      sliderInfo: undefined,
    };
  }

  updateCurrentItem = (e) => {
    const current = e.controlsContainer.querySelector('.current');
    const link = e.controlsContainer.querySelector('.tns-controls__pdf-link');

    if (!current || !link) return;

    current.innerHTML = this.state.currentIndex;
    link.setAttribute('data-sample-url', this.state.pdfLink);
  };

  getCurrentItem = (e) => {
    const items = e.slideItems;

    [].slice.call(items).forEach((item, index) => {
      if (item.classList.contains('tns-slide-active')) {
        this.state.currentItem = item;
        this.state.currentIndex = index + 1;
        this.state.pdfLink = item.getAttribute('data-sample-url');

        this.updateCurrentItem(e);
      }
    });
  };

  init = () => {
    if (!this.container && isMobile()) return;

    const slider = tns({
      container: this.container,
      items: 1,
      startIndex: 0,
      mouseDrag: true,
      autoplay: false,
      loop: false,
      nav: false,
      controlsText: ['', ''],
      onInit: (e) => {
        this.state.slideCount = e.slideCount;

        this.getCurrentItem(e);

        const positionBlock = `
          <a class="tns-controls__pdf-link" href="${this.state.pdfLink}" data-sample-url="${this.state.pdfLink}"></a>
          <div class="tns-controls__position">
            <span class="current">${this.state.currentIndex}</span>/${this.state.slideCount}
          </div>
        `;

        e.controlsContainer.insertAdjacentHTML('afterbegin', positionBlock);

        SamplesModal({
          sampleBtn: '.tns-controls__pdf-link',
        });

        e.prevButton.onclick = () => {
          slider.events.on('transitionEnd', () => {
            this.getCurrentItem(e);
          });
        };

        e.nextButton.onclick = () => {
          slider.events.on('transitionEnd', () => {
            this.getCurrentItem(e);
          });
        };
      },
    });

    this.state.sliderInfo = slider.getInfo();

    slider.events.on('transitionEnd', () => this.getCurrentItem(this.state.sliderInfo));
  };
}

export default MobileSlider;
